import { Box, Paper, Stack, Text } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';

import { TSDType } from '@e-origin/shared';

import { DropdownArrow } from '@components';
import classes from './TSDTypeView.module.css';

interface TSDTypeViewOptions {
  value: TSDType;
  label: string;
  'data-pw': string;
}

interface TSDTypeViewProps {
  value: TSDType;
  onChange: (value: TSDType) => void;
}

const tsdViewOptions: TSDTypeViewOptions[] = [
  { value: TSDType.PRELODGED, label: 'Pre-lodged', 'data-pw': 'temporary-storage-dropdown-pre-lodged' },
  { value: TSDType.COMBINED, label: 'Combined', 'data-pw': 'temporary-storage-dropdown-combined' },
  { value: TSDType.TRANSFERRED, label: 'Transferred', 'data-pw': 'temporary-storage-dropdown-transferred' },
];

export const TSDTypeView: React.FC<TSDTypeViewProps> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<TSDTypeViewOptions>(tsdViewOptions.find((opt) => opt.value === props.value));

  const ref = useRef(null);

  const onClickOutside = () => setIsOpen(false);

  const handleClickOutside = (event: any) => {
    if (ref.current && !ref.current.contains(event.target) && !event.target.closest('#dropdown-container')) {
      onClickOutside();
    }
  };

  const tsdViewSelected = (item: TSDTypeViewOptions) => {
    if (item.value !== props.value) {
      props.onChange(item.value);
      setSelectedOption(item);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return (
    <>
      <Box className={classes.container} id={'dropdown-container'} onClick={() => setIsOpen(!isOpen)}>
        <Stack gap={0}>
          <Text c={'grey'} fz={13}>
            Temporary storage view
          </Text>
          <Text c={'grey'} data-pw="temporary-storage-dropdown">
            {selectedOption?.label}
          </Text>
        </Stack>
        <DropdownArrow isOpen={isOpen} />
      </Box>

      {isOpen && (
        <Paper className={classes.dropdownList} ref={ref}>
          {tsdViewOptions.map((item: TSDTypeViewOptions) => {
            return (
              <Box
                className={classes.dropdownItem}
                key={item.value}
                onClick={() => {
                  tsdViewSelected(item);
                  setIsOpen(false);
                }}
                data-pw={item['data-pw']}
              >
                <Text c={'grey'} pl={15}>
                  {item.label}
                </Text>
              </Box>
            );
          })}
        </Paper>
      )}
    </>
  );
};
